import { createFileRoute } from "@tanstack/react-router";
import { FilaTransmissaoPage } from "@/pages/FilaTransmissaoPage";

export const Route = createFileRoute("/transmissoes/fila")({
  head: () => ({ meta: [{ title: "Fila de Transmissão — AXIS Comprovantes" }] }),
  component: FilaTransmissaoPage,
});
